import { getArticle } from "../../service/markdown.service";
import { useState, useEffect } from "react";
import React from "react";
import ReactMarkdown from "react-markdown";
import "./markdown.css";
import { useTranslation } from "react-i18next";

/**
 * Fetches markdown content from the server.
 * @param {string} name - The name of the article to fetch.
 * @param {string} [lang=en] - The language of the article to fetch.
 * @returns {{name: string, content: string, error: string}} - An object containing the name, content and error of the response.
 */
export const useGetMarkdown = (name) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const [response, setResponse] = useState({
    name: undefined,
    content: undefined,
    error: undefined,
  });

  useEffect(() => {
    async function fetchData() {
      const res = await getArticle(name, lang);
      setResponse(res);
    }
    fetchData();
  }, [name, lang]);

  return response;
};

/**
 * Hook to render markdown content.
 *
 * @param {string} children - The markdown content to be rendered.
 * @param {string} [className] - The CSS class name to be applied to the rendered markdown.
 * @returns {ReactNode} A React component that renders the markdown content.
 */
export function useRenderMarkdown(children, className) {
  return (
    <ReactMarkdown
      className={`article ${className}`}
      components={{
        h1: ({ ...props }) => <h1 className="" {...props} />,
        h2: ({ ...props }) => <h2 className="" {...props} />,
        h3: ({ ...props }) => <h3 className="" {...props} />,
        p: ({ ...props }) => <p className="" {...props} />,
        a: ({ ...props }) => (
          <a
            className=""
            target="_blank"
            rel="noopener noreferrer"
            {...props}
          />
        ),
        strong: ({ ...props }) => <strong className="strong" {...props} />,

        // Add more elements as needed
      }}
    >
      {children}
    </ReactMarkdown>
  );
}
